import { OverlayShellConfig } from "../../shared/overlay-shell/overlay.models";

export const CANCEL_EVENT_DIALOG_OVERLAY_CONFIG: OverlayShellConfig = {
  resizable: false,
  width: "auto",
  height: "auto",
};
